import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./App.css";
//Pages
import Home from "./components/Home/Home";
import Collection from "./components/Collections/Collection";
import MyNFT from "./components/myNFT/MyNFT";
import NFTBuySell from "./pages/NFTBuySell";
import Mint from "./pages/Mint";
//Media Query Management
import { isMobile } from "react-device-detect";

//Blocked view
import MobileHome from "./components/MobileView";
import { Alert } from "antd";

function App() {
  return (
    <Router>
      {!isMobile && (
        <Switch>
          <Route path="/" component={Collection} exact />
          <Route path="/create" component={Home} />
          <Route path="/myNFT" component={MyNFT} exact />
          <Route path="/trade/:nonce/:id" component={NFTBuySell} exact />
          <Route path="/mint" component={Mint} exact />
        </Switch>
      )}

      {isMobile && (
        <Switch>
          <Route path="/" component={MobileHome} />
        </Switch>
      )}
    </Router>
  );
}

export default App;
